module.exports = __webpack_public_path__ + "6b254ad7c2b9d7209ab342341f256bda.svg";